import React from 'react';
import Axios from 'axios';
import { Link } from 'react-router-dom';
import { ConnectedUserContext } from '../connectedUser-context';
import moment from 'moment';

import DashMod_Summary01 from './comps/DashMod_Summary01';
import PlayerDashboardOptA from './playerDashboardOptA';
import PlayerDashboardOptB from './playerDashboardOptB';

import AutoSuggestPlayer from '../shared/AutoSuggest/AutoSuggestPlayer';

import * as myConstClass from '../shared/constants/constants';

const CST_PROMO_DATE_01A = '2018-02-27';
const CST_PROMO_DATE_01B = '2018-03-31';

const bar = {
  labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
  datasets: [
    {
      label: 'My First dataset',
      backgroundColor: 'rgba(255,99,132,0.2)',
      borderColor: 'rgba(255,99,132,1)',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(255,99,132,0.4)',
      hoverBorderColor: 'rgba(255,99,132,1)',
      data: [65, 59, 80, 81, 56, 55, 40]
    }
  ]
};

const autoSuggTheme = {
	container: 'react-autosuggest-std__container',
	input: 'react-autosuggest-std__input',
	inputOpen: 'react-autosuggest-std__input--open',
	inputFocused: 'react-autosuggest-std__input--focused',
	suggestionsContainer: 'react-autosuggest-std__suggestions-container',
	suggestionsContainerOpen: 'react-autosuggest-std__suggestions-container--open',
	suggestionsList: 'react-autosuggest-std__suggestions-list',
	suggestion: 'react-autosuggest-std__suggestion',
	suggestionHighlighted: 'react-autosuggest-std__suggestion--highlighted',
	//suggestionFirst: 'react-autosuggest__suggestion--first',
	//sectionContainer: 'react-autosuggest__section-container',
	//sectionContainerFirst: 'react-autosuggest__section-container--first',
	//sectionTitle: 'react-autosuggest__section-title'
};

const DASHMOD_NBOF_DATACOL = 7;

class playerDashboard extends React.Component {

	static contextType = ConnectedUserContext;

  constructor(props) {
		super(props);
		this.state = {
			playerId: null,
			players: [],
			dashboardOption: 0,
			resultsTypeSelectorValue: 0,
			resultsType: myConstClass.RESTYPE_ALL,
			leagueTypeSelectorValue: 0,
			leagueType: myConstClass.LGTYPE_8B,
		};
	
		this.handlePlayerChange = this.handlePlayerChange.bind(this);
		this.handleResultsTypeChange = this.handleResultsTypeChange.bind(this);
		this.handleLeagueTypeChange = this.handleLeagueTypeChange.bind(this);
	}

	componentDidMount() {
	  // init depuis le contexte, une seule fois
	  const pid = this.context?.connectedUser?.user?.playerId ?? null;
	  this.setState({ playerId: pid });
	  this.prevContextPlayerId = pid; // NEW: mémo du dernier pid du contexte
	  if (this.context?.connectedUser) this.loadPlayersFromApi();
	}

	componentDidUpdate(prevProps, prevState) {
	  // Si le contexte a changé de joueur (ex: login/logout/switch), on resynchronise,
	  // mais seulement si l’utilisateur n’a PAS sélectionné manuellement un joueur.
	  const ctxPid = this.context?.connectedUser?.user?.playerId ?? null;
	  if (ctxPid !== this.prevContextPlayerId) {
	    this.prevContextPlayerId = ctxPid;
	    this.setState(state => ({
	      playerId: state.userPickedPlayer ? state.playerId : ctxPid,
	      userPickedPlayer: false, // on “oublie” l’override lors d’un changement de contexte
	    }));
	    if (this.context?.connectedUser) this.loadPlayersFromApi();
	  }
	}

	syncPlayerIdFromContext() {
	  const pid = this.context?.connectedUser?.user?.playerId ?? null;
	  if (pid !== this.state.playerId) {
	    this.setState({ playerId: pid });
	  }
	}

	loadPlayersFromApi = () => {
	  Axios.get('/api/players')
	    .then(res => this.setState({ players: res.data }))
	    .catch(err => console.error('players fetch error:', err));
	};

	render() {
		const { connectedUser } = this.context;

		// console.log('playerDashboard - RENDER');
		// console.log("playerId", this.state.playerId)
		// console.log(connectedUser)

		return (
			<div className="animated fadeIn">
			<div className="row">
			<div className="col-md-5">
    		<h5>Tableau de Bord</h5>
    		<h5>{connectedUser?.user?.name}</h5>
			</div>
			<div className="col-md-6">
    		<h5>La puissance des stats</h5>
			</div>

			<div className="col-md-1">
				<br/>
				<Link to="/userAccount">
					<img className="img-circle" src={connectedUser?.user?.picture} />
					</Link>
				</div>
   		</div>
			<hr/>

			{this.displayModules()}
   		</div>
		);
	}

	displayModules() {
		const { connectedUser } = this.context;
		const { playerId, resultsType, leagueType } = this.state;
		var specialAccess = false;

		if(moment().isAfter(CST_PROMO_DATE_01A) && moment().isBefore(CST_PROMO_DATE_01B)) {
			specialAccess = true;
			console.log('ACCES PROMOTIONNEL - MARS 2018');
		}

		// Loggued in or special access ?
		if (!connectedUser) {
			return (
				<div>
					<p>Vous devez être connecté pour visualiser votre tableau de bord.<br/>
					Cliquez sur <b>Se connecter</b> dans la barre de gauche.<br/></p>
					{specialAccess ? this.dispPromoMessage() : null}
				</div>
			);
		}

		else if (!connectedUser.user.memberActive && !specialAccess) {
			return (
				<div>
					<p>Vous devez être abonné pour visualiser votre tableau de bord.<br/>
					Cliquez ici pour plus d'information sur les abonnements.</p>
					<Link to='/userAccount' className="btn btn-primary"> Abonnement </Link>
				</div>
			);
		}

		else if (specialAccess && (playerId === null)) {
			return (
				<div>
					<p>Vous devez associer votre <b>PROFIL STATISTIQUE</b> dans la section <b>Votre Compte</b><br/>
					(Informations utilisateur - Modifier votre profil)</p>
					<Link to='/userAccount' className="btn btn-primary"> Votre Compte </Link>
				</div>
			);

		} else {
			return (
				<div>
					{this.dispSelectorsA()}
					{this.dispSelectorsB()}

          {((this.state.dashboardOption === 0) && playerId) ? 
          	<PlayerDashboardOptA playerId={playerId} resultsType={resultsType} leagueType={leagueType}/> : null}
					{((this.state.dashboardOption === 1) && playerId) ? 
						<PlayerDashboardOptB playerId={playerId} resultsType={resultsType} leagueType={leagueType}/> : null}
					{((this.state.dashboardOption === 2) && playerId) ? 
						<DashMod_Summary01 playerId={playerId} resultsType={resultsType} leagueType={leagueType}/> : null}
     		</div>
     	);
		}
	}

	dispSelectorsA() {
		return (
			<div>
				{this.displayPlayerIdSelector()}
				<div>
					<div className="row row-margin-bottom-20">
						{this.displayResultsTypeSelector()}
						{this.displayLeagueTypeSelector()}
	     		</div>
	   		</div>
     		<hr/>
   		</div>
		);
	}

	dispSelectorsB() {
		var btnClass = ['btn-secondary', 'btn-secondary', 'btn-secondary'];
		btnClass[this.state.dashboardOption] = 'btn-primary';

		return (
			<div>
				<div className="row">
				<div className="col-md-12">
					<button className={"btn " + btnClass[0] + " btn-margin-right-10"} onClick={this.btnClicked.bind(this, 0)}
						role="button">Sommaires et Évolution</button>
					<button className={"btn " + btnClass[1] + " btn-margin-right-10"} onClick={this.btnClicked.bind(this, 1)}
						role="button">Matchs et Affrontements</button>
					<button className={"btn " + btnClass[2]} onClick={this.btnClicked.bind(this, 2)}
						role="button">Ligues et saisons</button> 
				</div>
				</div>

				<hr/>
   		</div>
		);
	}

	btnClicked(btnIdx) {
		if (this.state.dashboardOption !== btnIdx) {
			this.setState({
				dashboardOption: btnIdx
			});
		}
	}

	displayPlayerIdSelector() {
		const { playerId } = this.state;
    return (
			<div className="row row-margin-bottom-20">
				<div className="col-md-10">
				<span className="text-uppercase font-weight-bold">Joueur</span><br/>
				<span>Rechercher un joueur en entrant quelques lettres de son prénom ou de son nom de famille</span>
			</div>
			<div className="col-md-4">
				<AutoSuggestPlayer theme={autoSuggTheme} playerId={playerId} dataChange={this.handlePlayerChange} />
			</div>
			</div>
    );
	}

	displayResultsTypeSelector() {
    return (
			<div className="col-md-3">
			<span className="text-uppercase font-weight-bold">Types de Résultats</span>
				<select className="form-control" 
					value={this.state.resultsTypeSelectorValue} onChange={this.handleResultsTypeChange}>
	        
	        <option value={0} key={"restype0"}>Ligues et tournois</option>
					<option value={1} key={"restype1"}>Ligues seulement</option>
					<option value={2} key={"restype2"}>Tournois seulement</option>
      	</select>
			</div>
    );
	}

	displayLeagueTypeSelector() {
    return (
			<div className="col-md-3">
				<span className="text-uppercase font-weight-bold">Type de jeu</span>
        <select className="form-control" 
        	value={this.state.leagueTypeSelectorValue} onChange={this.handleLeagueTypeChange}>
	        <option value={0} key={"lgtype0"}>Jeu du 8</option>
	        <option value={1} key={"lgtype1"}>Jeu du 9</option>
					<option value={2} key={"lgtype2"}>Jeu du 10</option>
      	</select>
			</div>
    );
	}

	dispPromoMessage() {
		return (
			<div>
				<img className="img-fluid" src="./img/abc.png" alt="promo-6-mois-40.00" width="200"/><br/><br/>
				<h5>Prix Spéciaux sur les Abonnements !</h5>
			</div>
		);
	}

	handlePlayerChange(dataValue) {
	  this.setState({
	    playerId: dataValue || null,
	    userPickedPlayer: true,
	  });
	}

	handleResultsTypeChange(e) {
	  const value = e.target.value;
	  const resultsTypeMap = {
	    '0': myConstClass.RESTYPE_ALL,
	    '1': myConstClass.RESTYPE_LEAGUE,
	    '2': myConstClass.RESTYPE_TOURNAMENT
	  };

	  this.setState({
	    resultsTypeSelectorValue: value,
	    resultsType: resultsTypeMap[value] || myConstClass.RESTYPE_ALL
	  });
	}

	handleLeagueTypeChange(e) {
	  const value = e.target.value;
	  const leagueTypeMap = {
	    '0': myConstClass.LGTYPE_8B,
	    '1': myConstClass.LGTYPE_9B,
	    '2': myConstClass.LGTYPE_10B
	  };

	  this.setState({
	    leagueTypeSelectorValue: value,
	    leagueType: leagueTypeMap[value] || myConstClass.LGTYPE_8B
	  });
	}

}

export default playerDashboard;
